/* eslint-disable no-nested-ternary */
/* istanbul ignore file */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  exerciseMyPrivacyRightsOld: {
    name: 'Exercise_My_Privacy_Rights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import(
      /* webpackChunkName: "Exercise_My_Privacy_Rights" */
      './pages/privacy/ExerciseMyPrivacyRights'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src//pages/privacy/ExerciseMyPrivacyRights')).ExerciseMyPrivacyRights
        : currentRouteName === 'Exercise_My_Privacy_Rights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise_My_Privacy_Rights',
    channel: null
  },
  californiaPrivacyRightsOld: {
    name: 'privacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import(
      /* webpackChunkName: "privacyReports" */
      // './pages/privacy/Privacy-Rights'
      './pages/privacy/PrivacyRightsReports/Privacy-Reports'

    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyRightsReports/Privacy-Reports')).PrivacyReports
        : currentRouteName === 'privacyReports'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California_Privacy_Rights',
    channel: null
  },
  exerciseMyPrivacyRights: {
    name: 'Exercise_My_Privacy_Rights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import(
      /* webpackChunkName: "Exercise_My_Privacy_Rights" */
      './pages/privacy/ExerciseMyPrivacyRights'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src//pages/privacy/ExerciseMyPrivacyRights')).ExerciseMyPrivacyRights
        : currentRouteName === 'Exercise_My_Privacy_Rights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise-My-Privacy-Rights',
    channel: null
  },
  privacySecurity: {
    name: 'privacyStatement',
    componentName: 'PrivacyStatementHOC',
    chunk: () => import(
      /* webpackChunkName: "privacyStatement" */
      './pages/privacy/PrivacyStatement/PrivacyStatementHOC'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyStatement/PrivacyStatementHOC')).PrivacyStatementHOC
        : currentRouteName === 'privacyStatementHOC'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyStatementHOC })));
    },
    path: '/:context?/privacy/Privacy-Security',
    channel: null
  },
  californiaPrivacyRights: {
    name: 'privacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import(
      /* webpackChunkName: "privacyReports" */
      // './pages/privacy/Privacy-Rights'
      './pages/privacy/PrivacyRightsReports/Privacy-Reports'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyRightsReports/Privacy-Reports')).PrivacyReports
        : currentRouteName === 'privacyReports'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California-Privacy-Rights',
    channel: null
  },
  myPreferenceCenter: {
    name: 'myPreferenceCenter',
    componentName: 'MyPreferenceCenterHOC',
    chunk: () => import(
      /* webpackChunkName: "myPreferenceCenter" */
      './pages/epc/MyPreferenceCenterHOC'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/epc/MyPreferenceCenterHOC')).MyPreferenceCenterHOC
        : currentRouteName === 'myPreferenceCenterHOC'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.MyPreferenceCenterHOC })));
    },
    path: '/:context?/privacy/MyPreferenceCenter',
    channel: null
  },
  privacyOverview: {
    name: 'privacyOverview',
    componentName: 'PrivacyOverview',
    chunk: () => import(
      /* webpackChunkName: "privacyOverview" */
      './pages/privacy/PrivacyOverview/Privacy-Overview'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyOverview/Privacy-Overview')).PrivacyOverview
        : currentRouteName === 'privacyOverview'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyOverview })));
    },
    path: '/:context?/privacy/privacy-and-security-at-a-glance',
    channel: null
  },
  privacyStatement: {
    name: 'privacyStatement',
    componentName: 'PrivacyStatementHOC',
    chunk: () => import(
      /* webpackChunkName: "privacyStatement" */
      './pages/privacy/PrivacyStatement/PrivacyStatementHOC'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyStatement/PrivacyStatementHOC')).PrivacyStatementHOC
        : currentRouteName === 'privacyStatementHOC'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyStatementHOC })));
    },
    path: '/:context?/privacy/privacy-and-security-statement',
    channel: null
  },
  privacyHome: {
    name: 'privacyHome',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "privacyHome" */
      './pages/privacy/Home'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/Home')).Home
        : currentRouteName === 'privacyHome'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/privacy/overview',
    channel: null
  },
  privacyReports: {
    name: 'privacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import(
      /* webpackChunkName: "privacyReports" */
      './pages/privacy/PrivacyRightsReports/Privacy-Reports'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/PrivacyRightsReports/Privacy-Reports')).PrivacyReports
        : currentRouteName === 'privacyReports'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California-Privacy-Rights-and-Report',
    channel: null
  },
  fraudCenter: {
    name: 'fraudCenter',
    componentName: 'FraudCenter',
    chunk: () => import(
      /* webpackChunkName: "FraudCenter" */
      './pages/privacy/FraudCenter'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/FraudCenter')).FraudCenter
        : currentRouteName === 'FraudCenter'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.FraudCenter })));
    },
    path: '/:context?/privacy/Fraud-Center',
    channel: null
  },
  supplyChainPrivacyPolicy: {
    name: 'supplyChainPrivacyPolicy',
    componentName: 'SupplyChainPrivacyPolicy',
    chunk: () => import(
      './pages/privacy/SupplyChainPrivacyPolicy'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/SupplyChainPrivacyPolicy')).SupplyChainPrivacyPolicy
        : currentRouteName === 'SupplyChainPrivacyPolicy'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SupplyChainPrivacyPolicy })));
    },
    path: '/:context?/privacy/driver-handheld-app-privacy-statement',
    channel: null
  },
  thirdPartyDisclosure: {
    name: 'thirdPartyDisclosure',
    componentName: 'ThirdPartyDisclosureRoute',
    chunk: () => import(
      './pages/privacy/ThirdPartyDisclosure/ThirdPartyDisclosureRoute'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/ThirdPartyDisclosure/ThirdPartyDisclosureRoute')).ThirdPartyDisclosureRoute
        : currentRouteName === 'ThirdPartyDisclosure'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThirdPartyDisclosureRoute })));
    },
    path: '/:context?/privacy/third-party-disclosure-list',
    channel: null
  }
});
